import { ResponsiveSection } from '@stitch-fix/mode-react';
import { JsonRteRenderer, type JsonRteRendererProps } from '../JsonRteRenderer';
export type ContentBlockProps = {
  data: JsonRteRendererProps['data'];
};
export const ContentBlock = ({
  data
}: ContentBlockProps) => <ResponsiveSection>
    <JsonRteRenderer data={data} />
  </ResponsiveSection>;